import { call, put } from "redux-saga/effects";
import { toast } from "react-toastify";
import {} from "../../Actions";
import { api } from "../../Config/ApiInterface";
import {
  getAllProcurementListSuccess,
  getAllProcurementListFailure,
  addProcurementSuccess,
  addProcurementFailure,
  updateProcurementFailure,
  updateProcurementSuccess,
  deleteProcurementFailure,
  deleteProcurementSuccess,
} from "../../Actions/Procurement/ProcurementAction";

// GET category
function* getProcurementsSaga(action) {
  try {
    const { page = 1, limit = 100, sortBy, ...filters } = action.payload || {};

    // Prepare query params
    const params = new URLSearchParams({
      page: String(page),
      limit: String(limit),
    });

    // Add dynamic filter (status, request_type, etc.)
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        params.append(key, value);
      }
    });

    const response = yield call(api.post, `requests/all?${params.toString()}`);
    if (response) {
      yield put(getAllProcurementListSuccess(response.data));
    } else {
      yield put(
        getAllProcurementListFailure(
          response.error || "Failed to fetch Procurements."
        )
      );
    }
  } catch (error) {
    yield put(getAllProcurementListFailure(error));
  }
}

//add category
function* addProcurementSaga(action) {
  let requestId = action.payload.id;
  try {
    const response = yield call(
      api.post,
      `requests/create`,
      action.payload?.body
    );
    if (response) {
      yield put(addProcurementSuccess(response.data));
      toast.success(response.message);
    } else {
      yield put(
        addProcurementFailure(response.error || "Failed to add category")
      );
    }
  } catch (error) {
    yield put(addProcurementFailure(error));
    toast.error("Failed to add category");
  }
}

// Edit category
function* updateProcurementSaga(action) {
  try {
    const payloadData = action.payload;
    const upload = action.payload.type==='upload';
    const updateDoc = action.payload.type==='status-update';
    const data = action.payload.data;
    
    const response = yield call(
      api.put,
      `/requests/${payloadData?.requestId}${data?.request_type===false && payloadData?.body?.status==='approved'?'/approve': upload ? "/upload-invoice":updateDoc ? "":'/invoice-files'}`,
      action.payload?.body
    );
    if (response) {
      yield put(updateProcurementSuccess(response.data));
      toast.success(response?.data?.message);
    } else {
      yield put(
        updateProcurementFailure(response.error || "Failed to update category")
      );
    }
  } catch (error) {
    yield put(updateProcurementFailure(error));
    toast.error("Failed to update category");
  }
}

//delete room type
function* deleteProcurementSaga(action) {
  try {
    const payloadData = action.payload;
    const response = yield call(api.delete, `/requests/${payloadData?.id}`);
    if (response) {
      yield put(deleteProcurementSuccess(response.data));
    } else {
      yield put(
        deleteProcurementFailure(
          response.error || "Failed to delete room types."
        )
      );
    }
    toast.success(response.message);
  } catch (error) {
    yield put(deleteProcurementFailure(error));
    toast.error("Failed to delete room types.");
  }
}

function* getProcurementsItemsSaga(action) {
  try {
    const { page = 1, limit = 100, name = "" } = action.payload || {};
    const params = new URLSearchParams({ page, limit, name });

    const response = yield call(api.post, `/requests/all`);
    if (response) {
      yield put(getAllProcurementListSuccess(response.data));
    } else {
      yield put(
        getAllProcurementListFailure(
          response.error || "Failed to fetch Procurements."
        )
      );
    }
    // toast.success(response.message);
  } catch (error) {
    yield put(getAllProcurementListFailure(error));
    // toast.error("Failed to fetch Procurements.");
  }
}
export {
  getProcurementsSaga,
  addProcurementSaga,
  updateProcurementSaga,
  deleteProcurementSaga,
  getProcurementsItemsSaga,
};
